import Vue from "vue";
import Router from "vue-router";
import {getCookie} from "../utils/util";

const Layout =()=>import( "@/layouts/YgstMainLayout");
const Login =()=>import(  "@/page/YgstManufacturerLogin.vue");
const Error =()=>import(  "@/page/home/404");

Vue.use(Router);
const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/loginsupplier',
    },
    {
      path: "/loginsupplier",
      component: Login,
    },
    {
      path: "/main",
      component: Layout,
      children:[
        {
          path: "/index",
          name: "index",
          // component: () => import( "@/page/home/Welcome.vue"),
          component: () => import( "@/page/home/Welcome.vue"),
        },
        {
          path: "/product/list",
          name: "ProductList",
          component: () => import( "@/page/product/ProductList.vue"),
          meta: {
            keepAlive: true
          }
        },
        {
          path: "/product/edit",
          name: "ProductEdit",
          component: () => import( "@/page/product/ProductEdit.vue"),
          redirect: "/product/info/edit",
          children: [
            {
              path: "/product/info/edit",
              name: "ProductInfoEdit",
              component: () => import( "@/page/product/ProductInfoEdit.vue"),
            },
            {
              path: "/product/image-text/edit",
              name: "ProductImageTextEdit",
              component: () => import( "@/page/product/ProductImageTextEdit.vue"),
            },
            {
              path: "/product/nutrients/edit",
              name: "ProductNutrientsEdit",
              component: () => import( "@/page/product/ProductNutrientsEdit.vue"),
            },
            {
              path: "/product/cooking/edit",
              name: "ProductCookingEdit",
              component: () => import( "@/page/product/ProductCookingEdit.vue"),
            }
          ]
        },
        {
          path: "/account/list",
          name: "YgstManufacturerAccountList",
          component: () => import( "@/ygst-page/manufacturer/ManufacturerAccountList.vue"),
        },
        {
          path: "/ygst/manufacturer/order-detail-list",
          name: "YgstManufacturerOrderDetailList",
          component: () => import( "@/ygst-page/manufacturer/ManufacturerOrderDetailList2.vue"),
        },
        {
          path: "/ygst/manufacturer/delivery-detail-list",
          name: "YgstManufacturerDeliveryDetailList",
          component: () => import( "@/ygst-page/manufacturer/ManufacturerDeliveryDetailList2.vue"),
        },
        {
          path: "/ygst/agent-manufacturer/order-detail-list",
          name: "YgstAgentManufacturerOrderDetailList",
          component: () => import( "@/ygst-page/agent-manufacturer/AgentManufacturerOrderDetailList.vue"),
        },
        {
          path: "/ygst/agent-manufacturer/delivery-detail-list",
          name: "YgstAgentManufacturerDeliveryDetailList",
          component: () => import( "@/ygst-page/agent-manufacturer/AgentManufacturerDeliveryDetailList.vue"),
        },
        {
          path: "/agent-manufacturer/product-list",
          name: "ManufacturerProductList",
          component: () => import( "@/page/manufacturer-product-list/ManufacturerProductList.vue"),
        },
      ]
      // children: [
      //   {
      //     path: "/sunshinecanteen/sunAccountmanagement",
      //     name: "sunAccountmanagement",
      //     component: AccountList,
      //   },
      //   {
      //     path: "/sunshinecanteen/sunOrderlist",
      //     name: "sunOrderlist",
      //     component: YgstSupplierOrderItemList,
      //   },
      //   {
      //     path: "/sunshinecanteen/sunAcceptancequery",
      //     name: "sunAcceptancequery",
      //     component: YgstSupplierOrderItemAcceptList,
      //   },
      //   {
      //     path: "/sunshinecanteen/sunOfferlist",
      //     name: "sunOfferlist",
      //     component: YgstSupplierQuoteList,
      //   },
      //   {
      //     path: "/commodity/commodityMain",
      //     name: "commodityMain",
      //     component: CommodityList,
      //   },
      //   {
      //     path: "/commodity/commodityOperating",
      //     // name: "commodityOperating",
      //     // component: CommodityAdd,
      //     redirect: "/commodity/edit",
      //   },
      //   {
      //     path: "/commodity/editCommodity",
      //     // name: "editCommodity",
      //     // component: editCommodity,
      //     redirect: "/commodity/edit",
      //   },
      //   {
      //     path: "/commodity/edit",
      //     name: "CommodityEdit",
      //     component: commodityEdit,
      //     redirect: "/commodity/info-edit",
      //     children: [
      //       {
      //         path: "/commodity/info-edit",
      //         name: "CommodityInfoEdit",
      //         component: commodityInfoEdit,
      //       },
      //       {
      //         path: "/commodity/image-text-edit",
      //         name: "CommodityImageTextEdit",
      //         component: commodityImageTextEdit,
      //       },
      //       {
      //         path: "/commodity/nutrients-edit",
      //         name: "CommodityNutrientsEdit",
      //         component: commodityNutrientsEdit,
      //       },
      //       {
      //         path: "/commodity/cooking-edit",
      //         name: "CommodityCookingEdit",
      //         component: commodityCookingEdit,
      //       }
      //     ]
      //   },
      // ]
    },
    {
      path: "/404",
      name: "error",
      component: Error
    },
    {
      path: "*",
      component: Error,
    }
  ]
})

function logged() {
  let token = getCookie('Token');
  return token && token !== "";
}

router.beforeEach((to, from, next) => {
      let needLogin = to.matched.some(item => item.meta.needLogin);

      if (needLogin && !logged()) {
        next({
          name: "login",
          params: {redirect: to}
        })
        return;
      }

      next();
    }
)

export default router;
